export default __webpack_public_path__ + "static/media/tb.2363bf90.png";